<template>
  <div class="content-source-view ">
    <div class="intro-wrapper">
      <div class="content">
        <h2>{{ currentType.name }}</h2>
        <p v-if="fixed" class="text-muted">
          <span>{{ $t("data.datamessage.intro") }}</span>
          <span>{{ currentType.name }}</span>
          <span>data.</span>
          <span>{{ $t("data.datamessage.fixed.1") }}</span>
          <span>{{ ` ${currentType.name}` }}</span>
          <span>{{ $t("data.datamessage.fixed.2") }}</span>
          <a href="https://help.icrobotics.com/integrations" target="_blank"> {{ $t("data.datamessage.fixed.3") }}</a>
        </p>
        <p v-else class="text-muted">
          <span>{{ $t("data.datamessage.intro") }}</span>
          <span>{{ currentType.name }}</span>
          <span>data.</span>
          <span>{{ $t("data.datamessage.custom.1") }}</span>
          <a href="https://help.icrobotics.com/integrations" target="_blank"> {{ $t("data.datamessage.custom.2") }}</a>
        </p>
        <p class="text-muted">{{ $t("data.datamessage.cta") }}</p>
        <button class="btn btn-primary-outline" @click="onAddDataSource(currentType)">+ data</button>
      </div>
    </div>
    <div class="content-sources">
      <div v-for="(contentSource, index) in matchingSources" :key="contentSource.id" class="source-wrapper">
        <ConnectorContentSource
          v-if="contentSource.fixedIntegration && isConnector(contentSource)"
          :formDataIndex="index"
          :contentSource="contentSource"
          :currentType="currentType"
          :formData="connectorSettings[toCamelCase(contentSource.enumName)]"
          :connectionStatus="connectionStatus[contentSource.id]"
          @update-selected="updateSelected"
          @check-connection="checkConnection"
        />
        <ContentSourceItem
          v-else
          :formDataIndex="index"
          :contentSource="contentSource"
          :currentType="currentType"
          @update-selected="updateSelected"
        />
      </div>
      <div class="no-sources" v-if="!fixed && !matchingSources.length">
        <p class="text-muted" v-html="$t('data.datamessage.no-data')"></p>
        <div class="actions">
          <button class="btn btn-primary-outline" @click="onAddDataSource(currentType)">+ data</button>
          <button class="btn btn-xs  delete-integration" @click="onDeleteType">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t("data.delete-category") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appHelper from "@/assets/js/appHelper.js";
import DataSourceModal from "@/components/modals/DataSourceModal";
import ConfirmModal from "@/components/modals/ConfirmModal";
import ContentSourceItem from "@/components/ContentSourceItem";
import ConnectorContentSource from "@/components/ConnectorContentSource";
export default {
  data() {
    return {
      connectionStatus: {}
    };
  },
  props: {
    contentSources: Array,
    matchingSources: Array,
    onDeleted: Function,
    currentType: Object,
    walkthrough: Boolean,
    primarySource: Object,
    fixedIntegrations: Array
  },
  methods: {
    toCamelCase(enumName) {
      return appHelper.toCamelCase(enumName);
    },
    isConnector(contentSource) {
      return this.$store.state.fixedConnectors.map((f) => f.value).includes(contentSource.contentType.name);
    },
    updateFixed(integration) {
      this.selectedSource = integration;
    },
    updateSelected() {
      this.$emit("update-selected", null);
    },
    onDeleteType() {
      if (this.matchingSources == 0) {
        this.$store
          .dispatch("deleteContentType", this.currentType)
          .then(() => {
            let updateType = this.currentType;
            updateType = null;
            this.$emit("update-selected", updateType);
            // this.$emit("success");
          })
          .catch(() => {
            this.$modal.show(
              ConfirmModal,
              {
                title: this.$t("data.delete-error-title2"),
                description: this.$t("data.delete-error-desc2"),
                hideCancelButton: true
              },
              { width: 350, height: "auto" }
            );
          });
      } else {
        this.$modal.show(
          ConfirmModal,
          {
            title: this.$t("data.delete-error-title1"),
            description: this.$t("data.delete-error-desc1"),
            hideCancelButton: true
          },
          { width: 350, height: "auto" }
        );
      }
    },

    onAddDataSource() {
      this.$modal.show(
        DataSourceModal,
        {
          isFixed: this.fixed,
          currentType: this.currentType,
          onSave: (customSource) => {
            if (customSource == "fixed") {
              this.onAddFixedIntegration(this.currentType);
            } else {
              customSource = JSON.stringify(customSource);
              this.$store
                .dispatch("createSource", customSource)
                .then(() => {
                  // this.$emit("success");
                })
                .catch((error) => {
                  this.error = true;
                });
            }
          }
        },
        { width: this.fixed ? 403 : 310, height: "auto", adaptive: true }
      );
    },

    onAddFixedIntegration(currentType) {
      this.$store.dispatch("createFixedIntegration", {
        integrationEnumName: currentType.name,
        settings: this.connectorSettings[appHelper.toCamelCase(currentType.name)]
      });
    },

    countUploads(c) {
      this.$emit("count-uploads", c);
    },

    checkConnection(id) {
      this.$set(this.connectionStatus, id, "");
      this.$store.dispatch("testSourceConnection", id).then((res) => {
        this.$set(this.connectionStatus, id, res[id]);
      });
    },
    checkConnections(ids) {
      this.connectionStatus = ids.reduce((acc, curr) => ((acc[curr] = ""), acc), {});
      this.$store.dispatch("testSourceConnections", ids).then((res) => {
        this.connectionStatus = res;
      });
    }
  },
  computed: {
    connectorSettings() {
      return this.$store.state.connectorSettings;
    },
    fixed() {
      if (this.matchingSources != 0) return this.matchingSources[0].hasOwnProperty("fixedIntegration");
      else return false;
    }
  },
  watch: {
    currentType: {
      handler: function() {
        const fixedIntegrationIds = this.fixedIntegrations.map((s) => s.id);
        const matchingSourcesIds = this.matchingSources.map((s) => s.id);
        const connectorIds = fixedIntegrationIds.filter((id) => matchingSourcesIds.includes(id));
        if (connectorIds.length > 0) {
          this.checkConnections(connectorIds);
        }
      },
      immediate: true
    }
  },
  components: {
    ContentSourceItem,
    ConnectorContentSource
  }
};
</script>

<style lang="less">
.content-source-view {
  // padding: 0 36px;
  margin-bottom: 20px;
  .intro-wrapper {
    .content {
      max-width: 350px;
    }
    .btn-primary-outline {
      width: max-content;
    }
    margin-bottom: 20px;
  }
  input[readonly],
  input[readonly="readonly"] {
    border-bottom: none !important;
    opacity: 0.7;
  }

  .no-sources {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    .delete-integration {
      svg {
        margin-right: 4px;
      }
      margin-left: 12px;
      width: max-content;
      &:hover {
        text-decoration: underline;
      }
    }
  }


    .content-sources {
      display: flex;
      flex-direction: column;
      gap: 18px;
    }
}

@media screen and (min-width: 920px) {
  .content-source-view {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 3fr 7fr;
    gap: 42px;
    justify-content: space-between;

    .intro-wrapper {
      display: flex;
      justify-content: center;
      flex-grow: 1;
      .content {
        display: flex;
        flex-direction: column;
        max-width: 400px;
      }
    }
  
    .source-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-grow: 1;
    }
    .source-form,
    .content-source-item {
      margin-top: 0;
      flex-grow: 1;
      max-width: 800px;
    }
  }
}
</style>
